import React from 'react';
import { Tool } from '../components/Tool';
import { HowToUse } from '../components/HowToUse';
import { Benefits } from '../components/Benefits';
import { FAQ } from '../components/FAQ';
import { Technical } from '../components/Technical';
import { CallToAction } from '../components/CallToAction';

export default function BlogTitleGenerator() {
  return (
    <main className="max-w-6xl mx-auto px-4 py-8 space-y-24">
      <Tool />
      <HowToUse />
      <Benefits />
      <FAQ />
      <Technical />
      <CallToAction />
    </main>
  );
}